'use client';
import { useState } from 'react';
import emailjs from '@emailjs/browser';
import { TextField, Button as MuiButton, Alert } from '@mui/material';

export default function ContactForm() {

  const [formData, setFormData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    travelDate: '',
    mobileNo: '',
    numGuests: '',
    description: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const templateParams = {
      firstName: formData.firstName,
      middleName: formData.middleName,
      lastName: formData.lastName,
      email: formData.email,
      travelDate: formData.travelDate,
      mobileNo: formData.mobileNo,
      numGuests: formData.numGuests,
      message: formData.description,
    };

    try {
      // Send email to admin/team
      await emailjs.send(
        "service_zi4fo7s",
        "template_bhveg4t",
        templateParams,
        "vQ_r-JxA_o1ZhChml"
      );

      // Send confirmation email to customer
      await emailjs.send(
        "service_zi4fo7s",
        "template_customer_reply",
        {
          to_email: formData.email,
          customer_name: formData.firstName,
          travel_date: formData.travelDate,
        },
        "vQ_r-JxA_o1ZhChml"
      );

      await fetch("https://script.google.com/macros/s/AKfycbzPCHMPtGryOTxx3fszYaNKG6-6HSWyUtA92lm9PVAC4Q9SUfwheFCufqnH-zhagNsd/exec", {
        method: "POST",
        body: new URLSearchParams({
          firstName: formData.firstName,
          middleName: formData.middleName,
          lastName: formData.lastName,
          email: formData.email,
          travelDate: formData.travelDate,
          mobileNo: formData.mobileNo,
          numGuests: formData.numGuests,
          message: formData.description
        })
      });


      setSubmitted(true);

      setTimeout(() => {
        setSubmitted(false);
      }, 5000);

      setFormData({
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        travelDate: '',
        mobileNo: '',
        numGuests: '',
        description: '',
      });

    } catch (error) {
      console.error("ERROR:", error);
      alert("Failed to send request. Check console.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

      {submitted && (
        <Alert severity="success" sx={{ mb: 3 }}>
          Message sent successfully!
        </Alert>
      )}

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px' }}>
          <TextField label="First Name" name="firstName" value={formData.firstName} onChange={handleChange} required />
          <TextField label="Middle Name" name="middleName" value={formData.middleName} onChange={handleChange} />
          <TextField label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} required />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>
          <TextField label="Email" name="email" type="email" value={formData.email} onChange={handleChange} required />
          <TextField label="Date of Travel" name="travelDate" type="date" InputLabelProps={{ shrink: true }} inputProps={{
            min: new Date().toISOString().split("T")[0], // ✅ disables past dates
          }} value={formData.travelDate} onChange={handleChange}
            required
          /></div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>
          <TextField label="Mobile Number" name="mobileNo" value={formData.mobileNo} onChange={handleChange} required />
          <TextField label="Number of Guests" name="numGuests" type="number" value={formData.numGuests} onChange={handleChange} required />
        </div>

        <TextField
          label="Tell us about your plans or inquiries"
          name="description"
          multiline
          rows={4}
          value={formData.description}
          onChange={handleChange}
          required
        />

        <MuiButton type="submit" variant="contained" disabled={loading}
          sx={{
            width: "220px",
            alignSelf: "center",
            padding: "12px",
            fontSize: "15px",
            fontWeight: "600",
            borderRadius: "8px",
            textTransform: "none",
            backgroundColor: "#f97316",
            "&:hover": {
              backgroundColor: "#d06214"
            }
          }}>
          {loading ? "Sending..." : "Send Request"}
        </MuiButton>

      </form>
    </div>
  );
}
